import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import CuadroInspectorComponent from './Inspectores/CuadroInspectorComponent';
import estilos from './Inspectores/CuadroInspectorComponent.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faPlus
} from '@fortawesome/free-solid-svg-icons'
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import InspectoresFormComponent from './Inspectores/InspectoresFormComponent';
import { useSelector, useDispatch } from 'react-redux'

import { getInspectores } from '../../redux/DucksUnidadInspeccion/InspectoresDuck'

import TablaInspectoresComponent from './Inspectores/TablaInspectoresComponent';
import PromoverInspectorComponent from './Inspectores/PromoverInspectorComponent';

library.add(faPlus)

function PanelInspectores(props) {

    const dispach = useDispatch();


    const [isVisible, setIsVisible] = React.useState(false);
    const [cajaBusqueda, setCajaBusqueda] = React.useState('');


    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1500,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        overflow: 'scroll',
        height: '85%',
    };

    //const inspectores = useSelector(store => store.Inspectores.inspectores)
    const [inspectores, setInspectores] = React.useState([])
    React.useEffect(() => {
        dispach(getInspectores()).then((res) => {
            setInspectores(res.payload.data.data)
        })
    }, []);


    const [open, setOpen] = React.useState(false);
    const [inspectorModify, setInspectorModify] = React.useState(null)

    const handleOpen = () => setOpen(true);

    const [openPromover, setOpenPromover] = React.useState(false);
    const [inspectorPromover, setInspectorPromover] = React.useState(null)
    const handleOpenPromover = () => setOpenPromover(true);


    const manejarOpen = () => {
        isVisible === false ? setIsVisible(true) : setIsVisible(false)
    }
    const handleClose = () => {
        dispach(getInspectores()).then((res) => {
            setInspectores(res.payload.data.data)
        })
        setInspectorModify(null)
        setOpen(false)
    }


    const handleModify = (inspector) => {
        handleOpen()
        setInspectorModify(inspector)
        dispach(getInspectores()).then((res) => {
            setInspectores(res.payload.data.data)
        })
    }

    const handlePromover = (inspector) => {
        handleOpenPromover()
        setInspectorPromover(inspector)
    }
    const handleClosePromover = () => {
        setInspectorPromover(null)
        setOpenPromover(false)
        dispach(getInspectores()).then((res) => {
            setInspectores(res.payload.data.data)
        })
    }

    const actualizarInspectores = () => {
        dispach(getInspectores()).then((res) => {
            setInspectores(res.payload.data.data)
        })
    }

    const modalFormInspectores = () => {
        return (
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <InspectoresFormComponent inspectorModify={inspectorModify} onClose={handleClose} actualizarInspectores={actualizarInspectores} ></InspectoresFormComponent>
                    </Box>
                </Fade>
            </Modal>
        )
    }
    const modalPromoverInspector = () => {
        return (
            <Modal
                open={openPromover}
                onClose={handleClosePromover}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    {<PromoverInspectorComponent inspectorPromover={inspectorPromover} onClose={handleClosePromover}></PromoverInspectorComponent>}
                </Box>
            </Modal>
        )
    }

    let inspectoresAux = [];
    const [aux, setAux] = React.useState([]);
    const [checkActivos, setCheckActivos] = React.useState(true);
    const [checkInactivos, setCheckInactivos] = React.useState(false);
    const [checkEnCapacitacion, setCheckEnCapacitacion] = React.useState(false);
    const [checkAcreditados, setCheckAcreditados] = React.useState(false);

    const handleBuscarInspectores = (event) => {
        setCajaBusqueda(event.target.value);

    }

    React.useEffect(() => {
        inspectoresAux = inspectores.filter(inspector => inspector.nombre.toUpperCase().includes(cajaBusqueda.toUpperCase()) || inspector.apellidos.toUpperCase().includes(cajaBusqueda.toUpperCase()))
        checkActivos ? inspectoresAux = inspectoresAux.filter(inspector => inspector.isactivo == true) : null;
        checkInactivos ? inspectoresAux = inspectoresAux.filter(inspector => inspector.isactivo == false || inspector.isactivo == undefined || inspector.isactivo == null) : null;
        checkEnCapacitacion ? inspectoresAux = inspectoresAux.filter(inspector => inspector.iscapacitacion == 1) : null;
        checkAcreditados ? inspectoresAux = inspectoresAux.filter(inspector => inspector.iscapacitacion == 0 && inspector.acreditacion != null && inspector.acreditacion != undefined) : null;

        setAux(inspectoresAux)
    }, [cajaBusqueda, checkActivos, checkInactivos, checkEnCapacitacion, checkAcreditados, inspectores])

    const handleCheckActivos = () => {
        if (checkActivos) { setCheckActivos(false); }
        else { setCheckActivos(true); setCheckInactivos(false); setCheckEnCapacitacion(false); setCheckAcreditados(false); }
    };
    const handleCheckInactivos = () => {
        if (checkInactivos) { setCheckInactivos(false); }
        else { setCheckActivos(false); setCheckInactivos(true); setCheckEnCapacitacion(false); setCheckAcreditados(false); }
    };
    const handleCheckEnCapacitacion = () => {
        if (checkEnCapacitacion) { setCheckEnCapacitacion(false); }
        else { setCheckActivos(false); setCheckInactivos(false); setCheckEnCapacitacion(true); setCheckAcreditados(false); }
    };
    const handleCheckAcreditados = () => {
        if (checkAcreditados) { setCheckAcreditados(false); }
        else { setCheckActivos(false); setCheckInactivos(false); setCheckEnCapacitacion(false); setCheckAcreditados(true); }
    };

    React.useEffect(() => {
        dispach(getInspectores()).then((res) => {
            setInspectores(res.payload.data.data)
        })
    }, [inspectorModify, open]);


    React.useEffect(() => {
        aux
    }, [aux])

    return (
        <Fragment><br />
            <div className='container'>
                <div className={`row`}>
                    <div className='col-9'>
                        {
                            //<h3>Periodo 1:  <strong>Semana del 01 al 05 de junio de 2022</strong></h3>
                            <h3>Inspectores</h3>
                        }
                    </div>
                    <div className='col-3 text-center'>
                        {
                            //<button style={{ margin: '1%' }} className={`btn btn-success ${estilos.zoom}`} onClick={manejarOpen}>{isVisible === false ? 'Modo Tabla' : 'Modo Credencial'}</button>
                        }
                        <button style={{ margin: '1%' }} className={`btn btn-success ${estilos.zoom}`} onClick={handleOpen}><FontAwesomeIcon icon={faPlus} /> Agregar nuevo Inspector</button>
                    </div>

                </div><br />
                <div className='row' style={{ marginLeft: '10%' }}>
                    <div className='col-3'>
                        <div className="form-check" style={{ display: 'inline-block !important' }}>
                            <input className="form-check-input" type="checkbox" checked={checkActivos} onChange={handleCheckActivos}>
                            </input>
                            <label className="form-check-label">
                                Activos
                            </label>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className="form-check" style={{ display: 'inline-block !important' }}>
                            <input className="form-check-input" type="checkbox" checked={checkInactivos} onChange={handleCheckInactivos}>
                            </input>
                            <label className="form-check-label">
                                Inactivos
                            </label>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className="form-check" style={{ display: 'inline-block !important' }}>
                            <input className="form-check-input" type="checkbox" checked={checkEnCapacitacion} onChange={handleCheckEnCapacitacion}>
                            </input>
                            <label className="form-check-label">
                                En capacitación
                            </label>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className="form-check" style={{ display: 'inline-block !important' }}>
                            <input className="form-check-input" type="checkbox" checked={checkAcreditados} onChange={handleCheckAcreditados}>
                            </input>
                            <label className="form-check-label">
                                Acreditados
                            </label>
                        </div>
                    </div>
                </div>
                <input className='form-control' type='text' placeholder='Ingrese el nombre o apellidos del inspector' onChange={handleBuscarInspectores} value={cajaBusqueda}></input> <br /><br />
                {/*  SE RENDERIZAN LAS CREDENCIALES   */}

                {isVisible === false ? (
                    <div className='row'>
                        {
                            aux.map((inspector, index) => {
                                return (
                                    <Fragment key={index}>
                                        {<CuadroInspectorComponent onPromover={handlePromover} onModify={handleModify} actualizarInspectores={actualizarInspectores} inspector={inspector}></CuadroInspectorComponent>}
                                    </Fragment>
                                )
                            })
                        }
                    </div>
                ) :
                    (
                        <TablaInspectoresComponent key={1} onPromover={handlePromover} onModify={handleModify} actualizarInspectores={actualizarInspectores} inspectores={inspectores}> </TablaInspectoresComponent>
                    )
                }
                <hr />
            </div>
            {modalPromoverInspector()}
            {modalFormInspectores()}
        </Fragment>
    );
};


export default withRouter(PanelInspectores)
